<aayn-ad-preview-card [selectedPlatform]="Platforms.Bing" [platforms]="platforms">
  <aayn-ad-preview-bing-single
    [businessName]="adPreviewService.performanceMax.businessName || ''"
    [headline]="adPreviewService.performanceMax.headline || ''"
    [description]="adPreviewService.performanceMax.description || ''"
    [imageUrls]="adPreviewService.performanceMax.imageUrls || []"
  >
  </aayn-ad-preview-bing-single>
</aayn-ad-preview-card>
